import { Component, OnInit, Input, ViewChildren, QueryList, Output, EventEmitter } from '@angular/core';
import { ContentfulContentRowComponent } from '../contentful-content-row/contentful-content-row.component';
import { ContentfulGenericPage } from './contentful-generic-page';
import { InfoBlockBehaviour } from '../info-block-behaviour';
import { ContentfulGenericPageService } from './contentful-generic-page.service';


@Component({
    selector: 'sbw-contentful-generic-page',
    templateUrl: './contentful-generic-page.component.html',
    styleUrls: ['./contentful-generic-page.component.css']
})

export class ContentfulGenericPageComponent implements OnInit {
    @ViewChildren(ContentfulContentRowComponent) contentRows: QueryList<ContentfulContentRowComponent>

    @Input() UrlSlugEntryTitle: string
    @Input() InfoBlockBehaviour: InfoBlockBehaviour
    @Output() onData = new EventEmitter<ContentfulGenericPage>()

    GenericPage: ContentfulGenericPage
    isLoading: boolean

    constructor(private contentfulGenericPageService: ContentfulGenericPageService) {
    }

    async ngOnInit() {
        this.isLoading = true
        this.GenericPage = await this.contentfulGenericPageService.getGenericPage(this.UrlSlugEntryTitle)
        this.onData.next(this.GenericPage)
        if (this.InfoBlockBehaviour == InfoBlockBehaviour.Accordion)
        {
            this.collapseAllRows(null);
        }
        this.isLoading = false
    }

    public onToggleExpandRow(event: any) {
        if (this.InfoBlockBehaviour == InfoBlockBehaviour.Accordion)
            this.collapseAllRows(event.target);
    }

    public collapseAllRows(excludeContentRow: any) {
        this.contentRows.forEach(contentRow => {
            if (contentRow != excludeContentRow) {
                contentRow.collapse()
            }
        });
    }
}
